import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table"; // Use react-bootstrap Table
import { useEffect, useState } from "react";
import axiosInstance from "../../../../hooks/axiosInstance";

export default function ViewCustomPaymentHistory({
    showHistoryView,
    closeModal,
    refreshPage,
    invoice_id,
}) {
    const [paymentHistory, setPaymentHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const handleClose = () => {
        closeModal();
    };

    const formatAmount = (amount) => {
        if (amount !== undefined && amount !== null) {
            return new Intl.NumberFormat().format(amount);
        }
        return amount;
    };

    useEffect(() => {
        if (invoice_id) {
            axiosInstance
                .get(`/user/payment/fetch_custom_payment_history/${invoice_id}`)
                .then((response) => {
                    setPaymentHistory(response.data.data.payment_history.data);
                    setLoading(false);
                })
                .catch((error) => {
                    setError("Error fetching payment history.");
                    setLoading(false);
                });
        }
    }, [invoice_id]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
        });
    };

    if (loading) {
        return (
            <Modal show={showHistoryView} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Loading Payment History...</Modal.Title>
                </Modal.Header>
                <Modal.Body>Loading...</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    if (error) {
        return (
            <Modal show={showHistoryView} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Error</Modal.Title>
                </Modal.Header>
                <Modal.Body>{error}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    const paymentTable = paymentHistory.length ? (
        <Table responsive="sm" striped bordered hover>
            <thead>
                <tr>
                    <th style={{ width: "20%" }}>#</th>
                    <th style={{ width: "40%" }}>Payment Date</th>
                    <th style={{ width: "40%" }}>Amount Paid</th>
                    {/* <th>Payment Method</th> */}
                </tr>
            </thead>
            <tbody>
                {paymentHistory.map((payment, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td> 
                        <td>{formatDate(payment.date_of_payment)}</td>
                        <td>{formatAmount(payment.amount_paid)}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    ) : (
        <p>No payment history available.</p>
    );

    return (
        <div className="ViewTransaction">
            <Modal show={showHistoryView} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Payment History</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ fontSize: "15px", lineHeight: "30px", overflowX: "auto" }}>
                    {paymentTable}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button
                        style={{ backgroundColor: "#c4281b", border: "none" }}
                        onClick={refreshPage}
                    >
                        Refresh
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}